import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Load languages
import en from "../locales/en.json";
import de from "../locales/de.json";

/**
 * Usage:
 * Update the translations in the /locales folder
 * Build a locale by running
 *
 * MacOs / Linux
 * REACT_APP_LANGUAGE=en npm run build
 *
 * Windows (cmd.exe)
 * set "REACT_APP_LANGUAGE=en" && npm run build
 *
 * Windows (Powershell)
 * ($env:REACT_APP_NOT_SECRET_CODE = "abcdef") -and (npm run build)
 *
 */

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // add the translations
    resources: { en: { translation: en }, de: { translation: de } },
    lng: process.env.REACT_APP_LANGUAGE || "en", // The Language to Compile
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
